import { Image, Text } from "@fluentui/react-components";
import classNames from "classnames";
import React from "react";
import LadySearchingImg from "../images/LadySearching.jpg";
import styles from "../styles/content.module.css";

type Props = {
  title?: string;
  instructions?: string;
};

const GettingStarted = ({ title, instructions }: Props) => {
  return (
    <div className={classNames("container", styles.imageContainer)}>
      <Image src={LadySearchingImg} alt="" />

      <Text as="h1" weight="bold" className={styles.labelContainer}>
        {title || "Let's get started! Choose your region and café."}
      </Text>

      <Text className={styles.spanContainer}>
        {instructions || "Then you can pick the station and add the menu for it."}
      </Text>
    </div>
  );
};

export default GettingStarted;
